import { useEffect, useState } from 'react';
import OptionsRangeFilter from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';

interface DateFilterProps {
  dateRange: { from: string; to: string } | null;
  onDateRangeChange: (range: { from: string; to: string } | null) => void;
}

/**
 * The range starts empty on purpose.
 *
 * This filter used to open on the current month, computed once when the module loaded. A
 * standing order created last year, or one whose payments are spent, then fell outside the
 * range and simply was not in the list - while the cards above the table still counted it, so
 * the two disagreed and there was no way to widen the range back to everything. The month is
 * still one click away through the range picker.
 */
const DateFilter = ({ dateRange, onDateRangeChange }: DateFilterProps) => {
  const [fromValue, setFromValue] = useState<string>(dateRange?.from ?? '');
  const [toValue, setToValue] = useState<string>(dateRange?.to ?? '');
  const [appliedRange, setAppliedRange] = useState<{ from: string; to: string } | null>(dateRange);

  useEffect(() => {
    setFromValue(dateRange?.from ?? '');
    setToValue(dateRange?.to ?? '');
    setAppliedRange(dateRange);
  }, [dateRange]);

  const handleRangeApply = (from: string, to: string) => {
    onDateRangeChange(from && to ? { from, to } : null);
  };

  return (
    <OptionsRangeFilter
      title="dateRange"
      filterType="range"
      rangeConfig={{
        type: 'date',
        fromPlaceholder: 'fromDate',
        toPlaceholder: 'toDate',
      }}
      fromValue={fromValue}
      setFromValue={setFromValue}
      toValue={toValue}
      setToValue={setToValue}
      appliedRange={appliedRange}
      setAppliedRange={setAppliedRange}
      onRangeApply={handleRangeApply}
      showMonthNavigation
    />
  );
};

export default DateFilter;
